import { InternalAxiosRequestConfig } from 'axios';
import { AuthenticationInterface } from 'core/services/types';

export class AuthMiddleware {
	authentication: AuthenticationInterface;

	constructor(authentication: AuthenticationInterface) {
		this.authentication = authentication;
	}

	async onRequest(
		config: InternalAxiosRequestConfig
	): Promise<InternalAxiosRequestConfig> {
		const token = this.authentication.getAccessToken();

		if (token) {
			config.headers.set('X-ACCESS-TOKEN', token);
		}

		return config;
	}
}
